import { ConfirmationReducerState } from './types';

export const getDefaultState = (): ConfirmationReducerState => ({
  isOpened: false,
  messages: []
});
